import { CommonModule, TitleCasePipe } from '@angular/common';
import { Component, HostBinding, Inject } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { RxwebValidators } from '@rxweb/reactive-form-validators';
import { IClaimForm } from 'app/claims/components/file-claim/models/forms/claim-form.interface';
import { ClaimFormService } from 'app/claims/components/file-claim/services/claim-form.form.service';
import { IApiClaim } from 'app/claims/models/api-claim.interface';
import { IClaimShipment } from 'app/claims/models/claim-shipment.interface';
import { IClaim } from 'app/claims/models/claim.interface';
import { IUserContacts } from 'app/claims/models/user-contacts.interface';
import { ClaimService } from 'app/claims/services/claim.service';
import { FormErrorsComponent } from 'app/shared/components/form-errors/form-errors.component';
import { FormService } from 'app/shared/services/form/form.service';

@Component({
    selector: 'upsc-claims-json-validator',
    templateUrl: './claims-json-validator.component.html',
    styleUrls: ['./claims-json-validator.component.scss'],
    standalone: true,
    providers: [
        ClaimService,
        ClaimFormService,
        FormService,
        TitleCasePipe,
    ],
    imports: [
        CommonModule,
        MatDialogModule,
        MatIconModule,
        MatButtonModule,
        MatFormFieldModule,
        MatInputModule,
        ReactiveFormsModule,
        FormErrorsComponent,
    ],
})
export class ClaimsJsonValidatorComponent {
    @HostBinding('class') public hostClass = 'claims-json-validator';

    public claimForm: FormGroup<IClaimForm>;
    public formGroup: FormGroup<{
        json: FormControl<string | null>,
        shipment: FormControl<string | null>,
        contacts: FormControl<string | null>,
    }>;
    public resultClaim: IClaim;
    public showErrors = false;

    public constructor(public dialogRef: MatDialogRef<ClaimsJsonValidatorComponent>,
                       @Inject(MAT_DIALOG_DATA) public data: unknown,
                       private readonly formBuilder: FormBuilder,
                       private readonly claimService: ClaimService,
                       private readonly claimFormService: ClaimFormService,
                       private readonly formService: FormService,
    ) {
        this.claimForm = this.claimFormService.claimForm;
        this.formGroup = this.formBuilder.group({
            json: new FormControl<string | null>(null, RxwebValidators.required()),
            shipment: new FormControl<string | null>(null, RxwebValidators.required()),
            contacts: new FormControl<string | null>(null, RxwebValidators.required()),
        });
    }

    public validateClaimsJson(event: Event): void {
        if (event) {
            event.preventDefault();
            event.stopPropagation();
        }

        this.resultClaim = null;
        this.showErrors = false;
        const json: IApiClaim = JSON.parse(this.formGroup.controls.json.value);
        const shipment: IClaimShipment = JSON.parse(this.formGroup.controls.shipment.value);
        const contacts: IUserContacts = JSON.parse(this.formGroup.controls.contacts.value);
        const claim = this.claimService.mapApiClaimToClaim(json, shipment, contacts);
        this.claimService.validateClaimShipment(claim);
        this.claimFormService.populateForm(claim);
        this.resultClaim = this.claimFormService.claimForm.value;
        this.formService.markAllAsTouchedAndDirty(this.claimForm, false);
        this.showErrors = true;
    }
}
